import styled from "styled-components";

const Container = styled.div``;

const Section = styled.div`
  &:not(:last-child) {
    border-bottom: 1px solid #ffffff17;
    padding-bottom: 8px;
  }
`;

const Profile = styled.div`
  display: flex;
`;

const ProfileImage = styled.div`
  width: 80px;
  margin-right: 16px;

  img {
    border-radius: 5px;
  }
`;

const ProfileDetails = styled.div`
  > div:nth-of-type(1) {
    font-size: 2rem;
    font-weight: 600;
    margin-bottom: 8px;
  }

  > div:nth-of-type(2) {
    display: flex;
    align-items: center;
  }
`;

const Icon = styled.div`
  width: 40px;
  margin-right: 8px;

  img {
    width: 100%;
  }
`;

const Level = styled.span`
  margin-left: 8px;
  font-weight: 500;
  font-size: 1.4rem;
`;

const DevBonuses = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  grid-gap: 8px;
  padding: 16px 0;

  > div {
    padding: 4px 16px;
    border: 2px solid #070d13;
    background: #0c121b;
    border-radius: 20px;
  }
`;

const TrainerDetailsStyles = {
  Container,
  Section,
  Level,
  Icon,
  DevBonuses,
  Profile,
  ProfileImage,
  ProfileDetails,
};

export default TrainerDetailsStyles;
